import React from 'react';
import styles from './footer.module.scss';


import facebookIcon from '../../img/svg/facebook.svg';
import instagramIcon from '../../img/svg/instagram.svg';
import twitterIcon from '../../img/svg/twitter.svg';


class Footer extends React.Component {
  render () {
    return (
      <footer className={styles.footer}>
        <div className={styles.container}>
          <ul className={styles.menu}>
            <li><a href="#">Get Started</a></li>
            <li><a href="#">Contact</a></li>
            <li><a href="#">About</a></li>
          </ul>
          <ul className={styles.socialMenu}>
            <li><a className={'facebook'} href="#"><img src={facebookIcon} alt="Facebook Icon, click to visit the CustomFIT Facebook page"/></a></li>
            <li><a className={'twitter'} href="#"><img src={twitterIcon} alt="Twitter Icon, click to visit the CustomFIT Twitter page"/></a></li>
            <li><a className={'instagram'} href="#"><img src={instagramIcon} alt="Instagram Icon, click to visit the CustomFIT Instagram page"/></a></li>
          </ul>
          <span className={styles.colophon}>&copy;2017 Super Developer World</span>
        </div>
      </footer>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/index.js